module.exports = __webpack_public_path__ + "static/media/conveyor.455120f6.svg";